import { render, staticRenderFns } from "./FCIO.vue?vue&type=template&id=b9b7fc1a&scoped=true&"
import script from "./FCIO.vue?vue&type=script&lang=js&"
export * from "./FCIO.vue?vue&type=script&lang=js&"
import style0 from "./FCIO.vue?vue&type=style&index=0&id=b9b7fc1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7fc1a",
  null
  
)

export default component.exports